import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'promocional',
    templateUrl: 'promocional.html'
})
export class PromocionalComponent {
    @Input('promocional') promocional;
    constructor() {}

}


// WEBPACK FOOTER //
// ./src/components/promocional/promocional.ts